function FileModalController(PackageService, CommonService, fileService, fleetService, userService, toasterService, $interval) {
  const ctrl = this;
  ctrl.installTypeMapper = CommonService.installTypeMapper;

  ctrl.$onInit = () => {
    ctrl.item = ctrl.resolve.item;
    ctrl.descriptor = ctrl.resolve.descriptor;
    ctrl.fleetList = []; // Load this when required.
    ctrl.deletionStatus = false;
    const getHeader = getValue(ctrl.item.header);
    ctrl.header = getHeader('header');
    ctrl.fileSet = getHeader('file_set');
    ctrl.fetchTrainUploadProgress();
    if(ctrl.item.inProgress) {
      ctrl.startProgressPoll();
    }
    ctrl.selectedTrains = [];
    ctrl.accordionGroups = {};
    ctrl.hasFileUploadToTrain = userService.hasFileUploadToTrain();
    ctrl.hasFileUpload = userService.hasFileUpload();
    ctrl.hasDeployPIS = userService.hasPISDeploy();
    ctrl.fileIsLogicPackage = ctrl.header.package_filename.includes('logic');
    ctrl.downloadInProgress = false;
    ctrl.hasManualUploadToTrains = __env.profile !== 'LU' && __env.profile !== 'VALE';
  };
  
  ctrl.$onDestroy = () => {
    $interval.cancel(ctrl.progressStatusPromise);
  };

  ctrl.startProgressPoll = () => {
    ctrl.lastProgressLoad = DateTime.now();
    ctrl.progressStatusPromise = $interval(ctrl.triggerUploadProgressLoad, 5000);
  };

  ctrl.triggerUploadProgressLoad = () => {
    if (ctrl.lastProgressLoad.diffNow('seconds').seconds < -5) {
      ctrl.fetchTrainUploadProgress();
    }
  };

  ctrl.fetchTrainUploadProgress = () => {
    
    PackageService.getUploadProgressPerFile(ctrl.item.id).then(data => {
      ctrl.uploadProgressList = data;
    });
  };

  const getValue = item => value => JSON.parse(item)[value];

  ctrl.collapse = index => {
    if (ctrl.accordionGroups[index]) {
      ctrl.accordionGroups[index] = false;
    } else {
      ctrl.accordionGroups[index] = true;
    }
  };

  ctrl.setDeleteStatus = status => {
    ctrl.deletionStatus = status;
  };

  ctrl.toggleSummaryMode = value => {
    ctrl.summaryMode = value;
  };

  ctrl.toggleUploadMode = async value => {
    ctrl.uploadMode = value;
    ctrl.fleetList = await fleetService.getAll();

    // Reset selected values when returning to first modal view
    if (!value) {
      ctrl.fleetList.map(train => train.selected = false);
      ctrl.selectedTrains = [];
    }
  };

  ctrl.getDescriptorStatus = () => (ctrl.descriptor === 'Unknown' || ctrl.descriptor === 'Deprecated') ? false : true;

  ctrl.startUpload = () => {
    let targetConsists = [];
    _.each(ctrl.selectedTrains, train => targetConsists.push(train.status.trainId));
    ctrl.uploadObject = {
      target: targetConsists,
      packageid: ctrl.item.id,
      fileName: ctrl.item.fileName,
      moduleType: ctrl.header.module_family_name,
    };
    // Close modal and send upload details to file management parent component
    ctrl.close({ $value: ctrl.uploadObject });
  };

  ctrl.chooseTrain = train => {
    // Remove selected train from list when clicking on already selected train
    if (train.selected) {
      train.selected = false;
      ctrl.selectedTrains = ctrl.selectedTrains.filter(item => item.trainId !== train.trainId);
    } else {
      train.selected = true;
      ctrl.selectedTrains.push(train);
    }
  };

  ctrl.downloadPackageFile = (fileName) => {
    ctrl.downloadInProgress = true;
    fileService.downloadPackageFile(fileName).then(response => {
      ctrl.downloadInProgress = false;
      if (response.statusCode !== 200) {
        toasterService.error('toaster.file-download-failure', fileName +  ' Status code:  ' +  response.status);
      } else {
        toasterService.success('toaster.file-download-success', ' ' + fileName);
        FileSaver.saveAs(response.response, fileName);
      }
    });
  }

  ctrl.cancelUpload = progressObject => {
    PackageService.abortUpload(progressObject.fileStatus.consist, progressObject.fileStatus.id).then(
      response => {
        // toasterService.success('toaster.package-upload-event', 'toaster.package-upload-start-success');
      },
      e => {
        // toasterService.error('toaster.package-upload-event', 'toaster.package-upload-start-failure');
        console.log(e);
      }
    );
  };

  // Close modal and send file delete details to file management parent component
  ctrl.confirmDeletion = () => {
    ctrl.close({ $value: parseInt(ctrl.item.id) });
  };
}

angular
  .module('package-management.module')
  .controller('FileModalController', FileModalController);
